import { render, staticRenderFns } from "./MinisitePaylink.vue?vue&type=template&id=b5b9e54c&"
import script from "./MinisitePaylink.vue?vue&type=script&lang=js&"
export * from "./MinisitePaylink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5b9e54c')) {
      api.createRecord('b5b9e54c', component.options)
    } else {
      api.reload('b5b9e54c', component.options)
    }
    module.hot.accept("./MinisitePaylink.vue?vue&type=template&id=b5b9e54c&", function () {
      api.rerender('b5b9e54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisitePaylink.vue"
export default component.exports